import {Component, OnInit, ViewChild} from '@angular/core';
import {CommissionFisofo} from '../../../model/commission-fisofo';
import {CatalogModel} from '../../../../app/model/other-catalogs-models';
import {DataTableDirective} from 'angular-datatables';
import {forkJoin, of, Subject} from 'rxjs';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {ToastrService} from 'ngx-toastr';
import {environment} from '../../../../environments/environment';
import {catchError, tap} from 'rxjs/operators';
import {CommissionFisofoService} from '../../../services/commission-fisofo.service';
import {CatEmployeeJobService} from '../../../../app/services/cat-employee-job.service';
import {ModalCommissionFisofoConfigurationComponent} from '../../../shared/modal-commission-fisofo-configuration/modal-commission-fisofo-configuration.component';

@Component({
  selector: 'app-commission-fisofo-configuration',
  templateUrl: './commission-fisofo-configuration.component.html',
  styleUrls: ['./commission-fisofo-configuration.component.css']
})
export class CommissionFisofoConfigurationComponent implements OnInit {

  // STATE
  public page='CommissionFisofo';
  public viewStatus:number=0;
  public loading:number=0;
  public listCommissionFisofo:CommissionFisofo[]=[];
  public listCommissionFisofoFiltered:CommissionFisofo[]=[];
  public selectedEmployeeJob:number[]=[];
  public errors:number;
  public hidden:boolean=true;
  public activeCommissions:boolean=false;

  // CATALOGS
  public employeeJobsCatalog:CatalogModel[]=[];
  public selectedEmployeeJobs:any[]=[];
  public selectedEmployeeJobsDD:string[]=[];

  // DATATABLE
  @ViewChild(DataTableDirective, {static: false})
  private datatableElement: DataTableDirective;
  public columns:any[]=[];

  // DATATABLE OPTIONS
  dtTrigger: Subject<any> = new Subject();
  dtOptions: any = {};

  constructor(
    private commissionFisofoService:CommissionFisofoService,
    private catEmployeeJobService:CatEmployeeJobService,
    private modalService:NgbModal,
    private toastr:ToastrService
  ) {}

  ngOnInit() {
    this.dtOptions={
      order:[],
      responsive: true,
      select: 'single',
      bLengthChange: true,
      searching :true,
      dom:'<"row"<"col"l><"col"<"text-center"B>><"col"f>><"row"<"col"t>><"row"<"col"i><"col"p>>',
      buttons: ['csv', 'excel'],
      // dom: 'Bfrtip',
      autoWidth:false,
      //pagingType: 'full_numbers',
      paging:true,
      language: {
        processing: 'Procesando...',
        search: 'Buscar:',
        lengthMenu: 'Mostrar _MENU_ elementos',
        info: 'Mostrando del _START_ al _END_ de _TOTAL_ elementos',
        infoEmpty: 'Mostrando ningún elemento.',
        infoFiltered: '(filtrado _MAX_ elementos total)',
        infoPostFix: '',
        loadingRecords: 'Cargando registros...',
        zeroRecords: 'No se encontraron registros',
        emptyTable: 'No hay datos disponibles en la tabla',
        paginate: {
          first: 'Primero',
          previous: 'Anterior',
          next: 'Siguiente',
          last: 'Último'
        },
        aria: {
          sortAscending: ': Activar para ordenar la tabla en orden ascendente',
          sortDescending: ': Activar para ordenar la tabla en orden descendente'
        },
        dom: 'Bfrtip',
        buttons: [
          'excel'
        ]
      }
    };

    this.dtOptions.pageLength=25;
    this.dtOptions.columns=this.makeColumns();
    this.dtOptions.columnDefs=this.getColumnRefs();
    this.dtOptions.rowCallback=this.getRowCallback;

    this.viewStatus = 1;
    this.getCatalogs();
  }
  ngAfterViewInit(): void {
    this.dtTrigger.next();
  }

  // EVENTS
  onAdd=()=> {
    let newModel = new CommissionFisofo();
    //newModel.commission = 0;
    this.openModalForm(newModel, 'create');
  }
  onEdit=(model:CommissionFisofo)=> {
    this.openModalForm(model, 'edit');
  }
  onDetail=(model:CommissionFisofo)=> {
    this.openModalForm(model, 'detail');
  }
  onDelete=(model:CommissionFisofo)=> {
    this.openModalForm(model, 'delete');
  }
  onToggleActive=(model:CommissionFisofo)=> {
    this.openModalForm(model, 'toggleActive');
  }

  // EVENTS
  onEmployeeJobChange=e=> {
    if(e.length > 0){
      this.selectedEmployeeJobs=e;
    } else {
      this.selectedEmployeeJobs=[];
    }
  };
  openModalForm=(model:CommissionFisofo, mode:string)=> {
    let modalRef=this.modalService.open(ModalCommissionFisofoConfigurationComponent, {centered:true, size:'lg', scrollable:true, backdrop:'static', keyboard:false});
    modalRef.componentInstance.commissionFisofo=model;
    modalRef.componentInstance.page=this.page;
    modalRef.componentInstance.mode=mode;
    modalRef.result.then(
      data=> console.log(data),
      reason=> {
        console.log(reason);
        if(reason === "success"){
          this.getCatalogs();
        }
      }
    );
  }

  // HELPERS
  rerender(): void {
    this.datatableElement.dtInstance.then((dtInstance) => {
      // Destroy the table first
      dtInstance.destroy();
      // Call the dtTrigger to rerender again
      this.dtTrigger.next();
    });
  }
  makeColumns=()=> {
    this.columns = [{
      title:'Grupo Puesto',
      data : 'commissionGroupDescr',
      className: 'text-center'
    },{
      title:'Producto',
      data : 'financingTypeDescr',
      className: 'text-center'
    },{
      title:'Convenio',
      data : 'afiliateDescr',
      className: 'text-center'
    },{
      title:'Plazo',
      data : 'paymentDescr',
      className: 'text-center'
    },{
      title:'Comisión Asesor',
      data:function(data) {
        return data.commission + '%'
      },
      className: 'text-center'
    },{
      title:'Comisión Gerente',
      data:function(data) {
        return data.commissionManager + '%'
      },
      className: 'text-center'
    },{
      title:'Comisión Regional',
      data:function(data) {
        return data.commissionRegional + '%'
      },
      className: 'text-center'
    },{
      title:'Comisión Coordinador',
      data:function(data) {
        return data.commissionCoordinator + '%'
      },
      className: 'text-center'
    }/*{
      title:'Avance',
      data:function(data) {
        return'De ' + data.advanceMin + '% a ' + data.advanceMax + '%'
      },
      className: 'text-center'
    }*/
    ,{
      title:'Tasa',
      data:function(data) {
        return'De ' + data.rateMin + '% a ' + data.rateMax + '%'
      },
      className: 'text-center'
    },{
      title:'Fecha',
      data:function(data) {
        return data.modifDate != null ? data.modifDate : data.createDate;
      },
      className: 'text-center'
    },{
      title:'Usuario',
      data:function(data) {
        return data.modifUserName != null ? data.modifUserName : data.createUserName;
      },
      className: 'text-center'
    },{
      title:'Estatus', data:function(data) {
        let active = data.activeId ? '<span class="badge badge-success">Activo <i class="icon-ok"></i></span>' : '<span class="badge badge-danger">Inactivo <i class="icon-cancel"></i></span>';
        return active;
      }, className:'text-center'
    },{
      title:'Acciones', data:function(data) {
        let menu='<div class="btn-group">\n' +
          '<span class="badge badge-info dropdown-toggle" data-toggle="dropdown" aria-expanded="false" role="button">Acciones</span>\n' +
          '<ul class="dropdown-menu">\n' +
          '  <li><a class="dropdown-item btn-detail clearfix"><i class="icon-eye"></i>&nbsp;&nbsp;Consultar</a></li>\n' +
          '  <li><a class="dropdown-item btn-edit"><i class="icon-pencil"></i>&nbsp;&nbsp;Editar</a></li>\n' +
          '  <li><a class="dropdown-item btn-delete"><i class="icon-trash"></i>&nbsp;&nbsp;Eliminar</a></li>\n' +
          '  <li><a class="dropdown-item btn-toggle-active"><i class="icon-toggle-on"></i>&nbsp;&nbsp;Activar/Desactivar</a></li>\n' +
          '</ul></div>';
        return menu;
      }, className:'text-center'
    }];
    return this.columns;
  }
  getColumnRefs=()=> {
    return [{ responsivePriority: 1, width:100, targets: -1 },
      { responsivePriority: 2, width:100, targets: -2 }];
  }
  getRowCallback=(row:Node, data:any[] | Object, index:number) => {
    let me = this;
    let btnEdit = $('td', row).find('a.btn-edit');
    let btnDetail = $('td', row).find('a.btn-detail');
    let btnDelete = $('td', row).find('a.btn-delete');
    let btnToggleActive = $('td', row).find('a.btn-toggle-active');

    $('td', row).unbind('dblclick');
    $('td', row).bind('dblclick', () => {
      me.onEdit(data as CommissionFisofo);
    });

    if (btnEdit) {
      btnEdit.unbind('click');
      btnEdit.bind('click', () => {
        me.onEdit(data as CommissionFisofo);
      });
    }
    if (btnDetail) {
      btnDetail.unbind('click');
      btnDetail.bind('click', () => {
        me.onDetail(data as CommissionFisofo);
      });
    }
    if (btnDelete) {
      btnDelete.unbind('click');
      btnDelete.bind('click', () => {
        me.onDelete(data as CommissionFisofo);
      });
    }
    if (btnToggleActive) {
      btnToggleActive.unbind('click');
      btnToggleActive.bind('click', () => {
        me.onToggleActive(data as CommissionFisofo);
      });
    }
    return row;
  }

  // INFO
  getCatalogs=()=> {
    this.loading = 1;
    forkJoin(
      this.commissionFisofoService.getCommissions()
    )
      .pipe(
        tap(([resp]:[any])=> {
          this.errors = 0;
          console.log(">> resp=", resp);
          if(resp.codeHttpStatus == 200){
            if(resp.data != null && resp.data.length > 0) {
              this.listCommissionFisofoFiltered = resp.data;
              console.log(">> this.listCommissionFisofoFiltered=", this.listCommissionFisofoFiltered);
            } else {
              this.listCommissionFisofoFiltered=[];
              this.toastr.info('No hay resultados búsqueda!');
            }
            this.datatableElement.dtInstance.then((dtInstance)=> {
              dtInstance.clear();
              dtInstance.rows.add(this.listCommissionFisofoFiltered).draw(false);
            });
          }else{
            this.toastr.error('Ha ocurrido un problema al ejecutar la consulta!');
            this.errors = this.errors + 1;
          }
          if(this.errors === 0){
            this.loading = 0;
          }
        }),
        catchError(err=> {
          console.log(">> catchError=", err);
          const error = err.error.message || err.error || err.message;
          return of(this.toastr.error(error));
        })
      )
      .subscribe();
  }

}
